import { DataBean } from "../DataBean";

export class DataForEndup extends DataBean {



    public async importEmployeeContractDataForEndup(filename: any, directory: any, dataStore: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importEmployeeContractDataForEndup_String_String_String", [filename, directory, dataStore]);
    }

}
